import { render, staticRenderFns } from "./AccountBookPage.vue?vue&type=template&id=c1b01984&scoped=true"
import script from "./AccountBookPage.vue?vue&type=script&lang=js"
export * from "./AccountBookPage.vue?vue&type=script&lang=js"
import style0 from "./AccountBookPage.vue?vue&type=style&index=0&id=c1b01984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b01984",
  null
  
)

export default component.exports